<template>
  <span class="svg-icon-commo-leave">
    <svg :width="width" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_63_4018)">
    <path d="M9 20H5C4.44772 20 4 19.5523 4 19V5C4 4.44772 4.44772 4 5 4H9C9.55228 4 10 3.55228 10 3C10 2.44772 9.55228 2 9 2H5C3.34315 2 2 3.34315 2 5V19C2 20.6569 3.34315 22 5 22H9C9.55228 22 10 21.5523 10 21C10 20.4477 9.55228 20 9 20Z" :fill="color"/>
    <path d="M19.5086 12L15.2157 16.2929C14.8252 16.6834 14.8252 17.3166 15.2157 17.7071C15.6063 18.0976 16.2394 18.0976 16.63 17.7071L21.63 12.7071C22.0205 12.3166 22.0205 11.6834 21.63 11.2929L16.63 6.29289C16.2394 5.90237 15.6063 5.90237 15.2157 6.29289C14.8252 6.68342 14.8252 7.31658 15.2157 7.70711L19.5086 12Z" :fill="color"/>
    <path d="M20.9229 11H8.92285C8.37057 11 7.92285 11.4477 7.92285 12C7.92285 12.5523 8.37057 13 8.92285 13H20.9229C21.4751 13 21.9229 12.5523 21.9229 12C21.9229 11.4477 21.4751 11 20.9229 11Z" :fill="color"/>
    </g>
    </svg>
  </span>
</template>

<script>
export default {
  props: {
    width: { type: Number, default: 24 },
    color: { type: String, default () { return '#FF2E38' } },
    color2: { type: String, default: '#E0E3E6' },
    isTwoTone: { type: Boolean },
    isSolid: { type: Boolean },
  }
}
</script>